<template>
    <div>
        <v-loader :full-screen="true"/>
        <loading-menu v-if="!isReady"/>
        <main-menu v-else/>
        <div class="main">
            <div v-if="isToastRequired" class="sandbox-message" :class="{'is-impersonating': isImpersonating}">
                <span v-if="isImpersonating">
                    <v-icon icon="info" class="icon-text inline-s"/><span><strong>Logged in as a merchant!</strong></span>
                </span>
                <span v-if="$isSandboxMode()">
                    <v-icon icon="map-marker" class="icon-text inline-s"/><span><strong>You are in the Sandbox Environment</strong></span>
                </span>
            </div>
            <div v-if="isReady">
                <router-view></router-view>
            </div>
            <v-icon-sprites/>
        </div>
    </div>
</template>

<script>
    import '@/style/main.css';

    import {vIcon, vIconSprites} from '@/components/form';
    import vLoader from '@/components/v-loader';
    import StateIdentifiers from '@/plugins/load-state/state-identifiers';
    import loadingMenu from '@/modules/layouts/components/loading-menu';
    import mainMenu from '@/modules/layouts/components/main-menu';

    export default {
        components: {
            vIconSprites, loadingMenu, mainMenu, vLoader, vIcon,
        },
        computed: {
            isReady() {
                return !this.$store.getters['loading/isLoading'](StateIdentifiers.application);
            },
            isImpersonating() {
                return this.$store.getters['user/isImpersonating'];
            },
            isToastRequired() {
                return this.$isSandboxMode() || this.isImpersonating;
            },
        },
    };
</script>
